module.exports = __webpack_public_path__ + "static/media/blue-cross-blue-shield-rhode-island-logo.b28e3772.svg";